import React, { Component } from 'react';
import { Switch , Route } from 'react-router-dom';

import Layout from './Hoc/Layout/Layout';
import Overview from './Components/Overview/Overview';
import Curriculum from './Components/Curriculum/Curriculum';
import OnSite from './Components/PartTime/PartTime';
import Remote from './Components/FullTime/FullTime';
import WhyUS from './Components/WhyUs/WhyUs';
import ContactData from './Containers/ContactData/Contact';

class App extends Component {
  render() {
    return (
        <div>
            <Layout>
                <Switch>
                    <Route path="/curriculum" component={Curriculum}/>
                    <Route path="/on-site" component={OnSite}/>
                    <Route path="/remote" component={Remote}/>
                    <Route path="/about" component={WhyUS}/>
                    <Route path="/events" component={ContactData}/>
                    <Route path="/" exact component={Overview}/>
                    <Route render={() => <div>page not found component</div>}/>
                </Switch>
            </Layout>
        </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js